import axiosInstance from "auth/FetchInterceptor";
import { DIEU_XE_API } from "constants/ApiConstant";

const DieuXeService = {};

DieuXeService.GetAll = function (data) {
  return axiosInstance.post(`${DIEU_XE_API}/search`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.SearchDieuChuyenXe = function (data) {
  return axiosInstance.post(`${DIEU_XE_API}/dieu-chuyen-xe/search`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.UpdateDieuChuyenXe = function (data) {
  return axiosInstance.put(`${DIEU_XE_API}/dieu-chuyen-xe`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.DeleteDieuChuyenXe = function (id) {
  return axiosInstance.delete(`${DIEU_XE_API}/dieu-chuyen-xe/${id}`, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.GetDetailDieuChuyenXe = function (id) {
  return axiosInstance.get(`${DIEU_XE_API}/dieu-chuyen-xe/${id}`, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.UpdateChuyenXeStatus = function (data) {
  return axiosInstance.put(`${DIEU_XE_API}/dieu-chuyen-xe/status`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.GroupPhieuToDieuChuyenXe = function (data) {
  return axiosInstance.post(
    `${DIEU_XE_API}/group-phieu-to-dieu-chuyen-xe`,
    data,
    {
      baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
    },
  );
};

DieuXeService.Create = function (data) {
  return axiosInstance.post(`${DIEU_XE_API}`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.Update = function (data) {
  return axiosInstance.put(`${DIEU_XE_API}`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.DeletePhieu = function (id) {
  return axiosInstance.delete(`${DIEU_XE_API}?id=${id}`, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.DeleteLoTrinh = function (id) {
  return axiosInstance.delete(`${DIEU_XE_API}/lo-trinh?id=${id}`, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.GetAllDrivers = function (data) {
  return axiosInstance.post(`${DIEU_XE_API}/driver/search`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.CreateDrivers = function (data) {
  return axiosInstance.post(`${DIEU_XE_API}/driver/create`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.DeleteDrivers = function (id) {
  return axiosInstance.delete(`${DIEU_XE_API}/driver/${id}`, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.UpdateDriverIsUse = function (data) {
  return axiosInstance.put(`${DIEU_XE_API}/driver/is-use`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.CreateChuyenXe = function (data) {
  return axiosInstance.post(`${DIEU_XE_API}/dieu-chuyen-xe`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.GetByid = function (id) {
  return axiosInstance.get(`${DIEU_XE_API}?id=${id}`, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

DieuXeService.CheckIsDriver = function () {
  return axiosInstance.post(`${DIEU_XE_API}/is-driver`,{}, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};
export default DieuXeService;
